import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUserTeamGetByManagerThunk } from "tm-shared/api";

import { ProgressLoader } from "@/app/ProgressLoader";
import Header from "@/components/Header";
import { MainContainer } from "@/components/Layout/Styled";
import Meta from "@/components/Meta";
import { SecondaryText } from "@/components/Typography/Styled";
import { useAppDispatch, useAppSelector } from "@/hooks/redux";

import { ActiveUserSection } from "./components/ActiveUserSection";
import { SearchInput } from "./components/SearchInput";
import { TeamHeader } from "./components/TeamHeader";
import { TeamList } from "./components/TeamList";
import { TeamStats } from "./components/TeamStats";
import { useLoadUserSchedule } from "./hooks/useLoadUserSchedule";
import { useTeamMembers } from "./hooks/useTeamMembers";
import { StyledScrollContent } from "./Styled";

const Team = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const { id: managerId } = useAppSelector((state) => state.user);
    const { team, lastUpdated } = useAppSelector((state) => state.sv);
    const { offlineMode } = useAppSelector((state) => state.offline);

    const [isLoading, setIsLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");

    const { handleLoadUserSchedule, isProcessing, queueProgress } =
        useLoadUserSchedule();
    const { activeUser, filteredMembers, teamStats, teamRoutes } =
        useTeamMembers(searchQuery);

    useEffect(() => {
        if (!managerId || offlineMode) return;

        setIsLoading(true);

        dispatch(getUserTeamGetByManagerThunk({ managerId }))
            .unwrap()
            .finally(() => {
                setIsLoading(false);
            });
    }, [dispatch, managerId, offlineMode]);

    return (
        <>
            <Meta title="Team" />

            <Header titleLoading={isLoading} />

            <MainContainer>
                <StyledScrollContent>
                    <TeamStats stats={teamStats} />

                    <TeamHeader lastUpdated={lastUpdated} />

                    {activeUser && (
                        <ActiveUserSection
                            routeId={teamRoutes[activeUser.userId]}
                            member={activeUser}
                            isProcessing={isProcessing}
                            onLoadSchedule={handleLoadUserSchedule}
                            onNavigate={() => navigate("/work-plan")}
                        />
                    )}

                    <SearchInput
                        value={searchQuery}
                        onChange={setSearchQuery}
                    />

                    {!team?.members?.length && isLoading && (
                        <SecondaryText>Завантажуємо команду…</SecondaryText>
                    )}

                    {team?.members && team.members.length > 0 && (
                        <TeamList
                            members={filteredMembers}
                            teamRoutes={teamRoutes}
                            searchQuery={searchQuery}
                            isProcessing={isProcessing}
                            onLoadSchedule={handleLoadUserSchedule}
                            onNavigate={() => navigate("/work-plan")}
                        />
                    )}
                </StyledScrollContent>
            </MainContainer>

            <ProgressLoader
                open={queueProgress.isRunning}
                tasks={queueProgress.tasks}
            />
        </>
    );
};

export default Team;
